import React, {Component, PropTypes} from 'react'
import {reduxForm} from "redux-form"
import {connect} from 'react-redux'
import Modal from 'react-modal'
import styles from './outbox.scss'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import {setCheckBox, selectVisibleItems, selectItems, filterOutbox, archiveEmail, archiveAllEmail,
    getOutbox, setNotification, setOutboxEmailOpened, setOutboxSubModule, setSeenOutboxEmail,
    sendEmailBySender, loadEmailServer, showEmailServerConfigModal,hideEmailServerConfigModal, saveEmailServer} from 'state/actions'
import {map} from 'lodash/collection'
import SelectWrap from '../../components/shared/select/SelectWrap'
import RefreshBtn from '../refreshBtn'
import {RenderEmails} from './outboxHelpers'
import { DatePicker } from 'components/shared/datePicker'
import moment from 'moment'
import i18n from 'lib/i18n'
import {isAnEmail} from 'lib/validator'
import HtmlContent from 'elements/HtmlContent'
import cs from 'classnames'
import {customModalStyles} from './outboxHelpers'
import {fetchSrcValuesFromHtml} from '../emailSender/helpers.jsx'
import EmailServerConfigDialog from '../emailSender/emailServerConfigDialog'

const _ = i18n('outbox')
const _emailSenderTranslates = i18n('emailSender')
const EMAIL_STATUS_FAILED = 'failed'
const EMAIL_STATUS_BOUNCED = 'bounced'
const EMAIL_STATUS_RESENT = 'resent'

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
		position: 'relative',
		top: 'initial',
		bottom: 'initial',
		left: 'initial',
		right: 'initial',
		maxHeight: '90%',
		overflow: 'auto',
		padding: '0',
    }
}

@reduxForm({
	form: "OutboxEmailList",
	fields: ["startDate", "endDate"],
	initialValues: {},
})
@connect(
    (state) => {
        const {outbox: {filter, selectValue, modalIsOpen, opened, subModule, startDate, endDate},app:{lang}} = state
        return {
            filter,
            selectValue,
            modalIsOpen,
            opened,
            subModule,
            startDate,
            endDate,
            lang,
            emailServerConfigModalIsOpen: state.emailSender.emailServerConfigModalIsOpen,
            serverConfigIsSaved: state.emailSender.serverConfigIsSaved,
        }
    },
    {setNotification, setCheckBox, selectVisibleItems, filterOutbox, archiveEmail, archiveAllEmail, getOutbox, selectItems, setSeenOutboxEmail}
)

export default class OutboxEmailList extends React.Component {
	static propTypes = {
        filter: PropTypes.string.isRequired,
        selectValue: PropTypes.string.isRequired,
        setCheckBox: PropTypes.func.isRequired,
		selectVisibleItems: PropTypes.func.isRequired,
		selectItems: PropTypes.func.isRequired,
		filterOutbox: PropTypes.func.isRequired,
		archiveEmail: PropTypes.func.isRequired,
		archiveAllEmail: PropTypes.func.isRequired,
        getOutbox: PropTypes.func.isRequired,
		setNotification: PropTypes.func.isRequired,
		emails: React.PropTypes.array.isRequired,
        zoomTo: React.PropTypes.func.isRequired,
        startDate: React.PropTypes.any,
        endDate: React.PropTypes.any,
		handleSubmit: React.PropTypes.func.isRequired,
		setSeenOutboxEmail: React.PropTypes.func.isRequired,
    }

    constructor(props) {
		super(props)
        this.state = {visibilityOf: {}, archiveIsOpen: false, statusExplainerIsOpen: false,
        resendEmailPopupIsOpen: false, resendToAddress: '', resendingButtonDisabled: false,
        resendEmailInstance: {}, resendToAddressValid: false, resendToAddressTouched: false,
        selectedItem: null}
	}

    componentDidMount() {
        this.refresh()
	}

	refresh(force) {
		const {getOutbox} = this.props
		getOutbox(force)
	}

	check(ev, id) {
		ev.stopPropagation()
		const {setCheckBox} = this.props
		setCheckBox(id)
	}

	archiveBtn(checkedItemCount, items) {
        const {archiveEmail, taskConvertionSecurity, handleMakeAsTodo} = this.props

		return (
			<div className={styles.buttonContainer}>
				<input
                    onClick={(ev) => archiveEmail(items)}
					disabled={!checkedItemCount}
					type="button"
					className={styles.greyButton}
					value={_("delete")}
				/>
				<input
					onClick={() => this.archiveAllPopupToggle()}
					disabled={!(items && items.length || false)}
					type="button"
					className={styles.greyButton}
					value={_("deleteAll")}
				/>
                {taskConvertionSecurity &&
                    <button onClick={handleMakeAsTodo}
                        disabled={!checkedItemCount}
                        className={`${styles.backToList} ${styles.greyButton}`}>
                        {_('makeAsTodo')}
                    </button>
                }
			</div>
		)
	}

	archiveAllPopupToggle() {
		this.setState({archiveIsOpen: !this.state.archiveIsOpen})
	}

	archiveAllConfirmHandle() {
        const {archiveAllEmail, selectItems, emails, setNotification} = this.props
        const filteredEmails = emails.filter(item => !item.hidden)
		selectItems(filteredEmails)
		archiveAllEmail(filteredEmails)
		this.archiveAllPopupToggle()

		const itemsLength = filteredEmails && filteredEmails.length || 0
		const msg = `${_('all')} ${itemsLength} ${_('emailsDeleted')}`
		setNotification(msg, 'info')
	}

	archiveAllPopup() {
        const {emails} = this.props
        const filteredEmails = emails.filter(item => !item.hidden)
		const itemsLength = filteredEmails && filteredEmails.length || 0
		const titleMsg = `${_('all')} ${itemsLength} ${_('numOfSelectedMsg')}`
		const msg = `${_('doYouWantToArchiveAll')}`
		return (
			<div className={styles.archiveModalContent}>
				<span className={styles.title}>{titleMsg}</span>
				<span className={styles.message}>{msg}</span>
				<div className={styles.archiveModalButtons}>
					<span
						onClick={() => this.archiveAllPopupToggle()}
						className={styles.cancel}
					>
						{_("cancel")}
					</span>
					<input
						onClick={() => this.archiveAllConfirmHandle()}
						type="button"
						className={styles.greyButton + " enabled"}
						value={_("deleteAll")}
					/>
				</div>
			</div>
		)
	}

	handleCheckAll = () => {
		const {selectVisibleItems, setNotification} = this.props
		const {allSelected, visibleIds} = this

		if (!allSelected) {
			const msg = `${_('all')} ${visibleIds.length} ${_('numOfSelectedMsg')}`
			setNotification(msg, 'info')
		}
        selectVisibleItems(visibleIds)
	}

	handleVisibleList = (visibleIds) => {
		const visibilityOf = {}
		for (const id of visibleIds) {
			visibilityOf[id] = true
		}
		this.visibleIds = visibleIds
		this.setState({visibilityOf})
	}

    saveForm = (data) => {
        const {selectValue} = this.props
        this.props.filterOutbox(selectValue, data.startDate, data.endDate)
    }

    /**
     * This function handle the email status modal opening
     * @param {object} item - one email record
     */
    onItemStatusClick(item) {
        const {dispatch, setSeenOutboxEmail} = this.props
        setSeenOutboxEmail(item.id)

        // status check
        if (!item || (item.status != EMAIL_STATUS_FAILED && item.status != EMAIL_STATUS_BOUNCED)) {
            return
        }

        this.setState({statusExplainerIsOpen: item})
    }

    /**
     * This will render the modal content of status explainer in case of error.
     */
    statusExplainerPopup() {
        const {statusExplainerIsOpen} = this.state
		return (
			<div className={styles.archiveModalContent}>
				<span className={styles.title}>{_('emailStatusMessageModalTitle')}</span>
                <span className={styles.message}>
                    <div className={styles.emailBodyContainer}>
                        {!statusExplainerIsOpen.statusMessage || statusExplainerIsOpen.statusMessage.length == 0 ?
                            _("noMessageAboutFail") :
                            <HtmlContent content={statusExplainerIsOpen.statusMessage} className={styles.content}/>
                        }
                    </div>
                </span>
				<div className={styles.archiveModalButtons}>
					<input
						onClick={() => {
                            this.setState({statusExplainerIsOpen: false})
                        }}
						type="button"
						className={styles.greyButton + " enabled"}
						value={_("ok")}
					/>
				</div>
			</div>
		)
    }

    /**
     * Get the translation of the current item status for the overview
     * @param {*} item
     */
    getStatusTextForList(item) {
        let status = item.status

        // in case of resent flag is set, the show resent in place of bounced or failed
        if (item.wasResent) {
            status = 'resent'
        }

        return (status && _(status) || "")
    }

    /**
     * This will render the modal content of status explainer in case of error.
     */
    resendEmailPopup() {
        const {resendToAddress, resendingButtonDisabled, resendEmailInstance, resendToAddressValid,
            resendToAddressTouched} = this.state
		return (
			<div className={styles.archiveModalContent}>
				<span className={styles.title}>{_('resendEmailModalTitle')}</span>
                <span className={styles.message}>
                    <div className={styles.resendModalContainer}>
                        <div className={styles.formInputContainer}>
                            <div>{_('resendEmailModalDescription')}</div>
                            <label className={cs(styles.formLabel, styles.width3)}>{_('typeANewEmailAddressToSend')}:* </label>
                            <input
                                className={cs(styles.formInput, styles.width7, styles.ieFixHeight)}
                                type="text"
                                value={resendToAddress}
                                onChange={(e)=>{
                                    this.changeResendToAddress(e.target.value)
                                }}
                                onBlur={() => {
                                    this.onBlurResendToAddress()
                                }}
                            />
                        </div>
                        {!resendToAddressValid && resendToAddressTouched &&<div>
                            <div className={styles.errorMessage}>
                                {_('emailAddressIsRequired')}
                            </div>
                        </div>}
                    </div>
                </span>
                <div className={styles.archiveModalButtons}>
                    <div
                        onClick={()=>{
                            this.setState({resendEmailPopupIsOpen: false})
                        }}
                        className={styles.cancel}
                    >
                        {_("cancel")}
                    </div>
					<input
						onClick={() => {
                            this.resendEmail(resendEmailInstance)
                        }}
						type="button"
						className={styles.greyButton + ((resendingButtonDisabled || !resendToAddressValid) ? " disabled" : " enabled")}
                        value={_("resendEmail")}
                        disabled={resendingButtonDisabled || !resendToAddressValid}
					/>
				</div>
			</div>
		)
    }

    /**
     *
     * @param {*} value
     */
    changeResendToAddress(value) {
        this.setState({
            resendToAddress: value,
        })
    }

    onBlurResendToAddress() {
         // check validity
         const {resendToAddress} = this.state
         let valid = true

         if (!resendToAddress || !isAnEmail(resendToAddress)) {
             valid = false
         }

         this.setState({
             resendToAddressValid: valid,
             resendToAddressTouched: true
         })
    }

    onResendEmailClick(item) {
        const {dispatch} = this.props
        const senderEmailFieldValue = item.senderEmail
        if(!item.senderName){
            //this case sender email has no emailserver configured ore is lacking senderName param

            //double check if there is a email server and it has sender name
            dispatch(loadEmailServer(senderEmailFieldValue)).then(res => {
                if( res && res.senderName && res.senderName.length > 0 )
                {
                    this.doOpenResendModal(item)
                }else{
                    dispatch(showEmailServerConfigModal(senderEmailFieldValue))
                }
            }).catch(err => {
                this.setState({selectedItem: item})
                dispatch(showEmailServerConfigModal(senderEmailFieldValue))
            })

        }else{
            //continue to resend modal
            this.doOpenResendModal(item)
        }
    }

    doOpenResendModal(item) {
        this.setState({
            resendEmailInstance: JSON.parse(JSON.stringify(item)),
            resendEmailPopupIsOpen: true
        })
    }

    /**
     *
     * @param {*} resendEmailInstance
     */
    resendEmail(resendEmailInstance) {
        const {resendToAddress} = this.state
        const {dispatch} = this.props
        this.setState({resendingButtonDisabled: true})

        const finalEmail = {
            fromName: resendEmailInstance.senderName || "",
            senderEmail: resendEmailInstance.senderEmail || "",
            cleanSenderEmail: resendEmailInstance.cleanSenderEmail || resendEmailInstance.senderEmail,
            to: resendToAddress,
            subject: resendEmailInstance.subject,
            message: resendEmailInstance.content, // signature is included
            signatureHtml: "", // content also contains because this is a resend
            disclaimerHtml: "", // content also contains because this is a resend
            signatureImageUrls: fetchSrcValuesFromHtml(resendEmailInstance.content),
            attachments: resendEmailInstance.attachments,
            hardAttachments: resendEmailInstance.hardAttachments,
            recipient: resendEmailInstance.recipient,
            templateId: resendEmailInstance.templateId,
            templateIndexType: resendEmailInstance.templateIndexType,
            templateLowValue: resendEmailInstance.templateLowValue,
            templateTitle: resendEmailInstance.templateTitle,
            templateAbbr: resendEmailInstance.templateAbbr,
            clientId: resendEmailInstance.clientId,
            contractId: resendEmailInstance.contractId,
            claimId: resendEmailInstance.claimId,
            signatureId: resendEmailInstance.signatureId,
            resentOf: resendEmailInstance._id,
            uploadedOnModule: resendEmailInstance.uploadedOnModule
        }

        dispatch(sendEmailBySender(finalEmail))
        .then(()=>{
            this.setState({resendEmailPopupIsOpen: false})
            this.setState({resendingButtonDisabled: false})
            this.setState({resendToAddress: ""})
            this.refresh(true)
        })
        .catch(()=>{
            this.setState({resendEmailPopupIsOpen: false})
            this.setState({resendingButtonDisabled: false})
            this.setState({resendToAddress: ""})
            this.refresh(true)
        })
    }

    /**
     * Render hook of react.
     */
    render() {
        const {emails, zoomTo, filterOutbox, selectValue, getOutbox, opened,
            fields: {startDate, endDate}, handleSubmit, emailServerConfigModalIsOpen, dispatch} = this.props
        const {visibilityOf, archiveIsOpen, statusExplainerIsOpen, resendEmailPopupIsOpen, selectedItem} = this.state
		const checkedItemCount = emails.reduce((sum, item) => sum + (item.checked ? 1 : 0), 0)
		const allSelected = emails && emails.length > 0 && emails.every(item => (
			visibilityOf[item.id] ? item.checked : true
        ))
        this.allSelected = allSelected

        // filter the hidden email from the list, sort in order by sorting rules
        const filteredEmails = emails
            .filter(oneEmail => !oneEmail.hidden)
            .map((oneEmail)=>{
                let priority = moment(oneEmail.sentDate).format("YYYYMMDDHHmmss")
                let listOfPriorityStatuses = [EMAIL_STATUS_BOUNCED, EMAIL_STATUS_FAILED]
                let hasStatusWithPriority = listOfPriorityStatuses.includes(oneEmail.status)

                // give a higher priority in case of error or bounce and not seen, exception if the email was already resent
                // rule description in: BEWB-156
                if (oneEmail.status == hasStatusWithPriority && !oneEmail.seenInOutbox && !oneEmail.wasResent) {
                    priority = "9" + moment().format("YYYYMMDDHHmmss") + oneEmail.seenInOutbox
                }

                oneEmail.priority = priority

                return oneEmail
            })

		// Needs to be defined here so translations are updated
		const filterOptions = [
			{value: 'showAll', label: _('showAll')},
			{value: 'showSent', label: _('showSent')},
			{value: 'showUnSent', label: _('showUnSent')},
        ]
        if (!emails) {return false}

        const onSubmit = handleSubmit(this.saveForm)

		return (
            <div className={`${styles.results} ${opened ? styles.hidden : 'visible'}`}>
                <Table
                    onVisibleChange={this.handleVisibleList}
                    topPaginationElemL={
                        [
                            <div key="x1z" className="filterSelectContainer">
                                <SelectWrap
                                    key="s"
                                    value={selectValue}
                                    options={filterOptions}
                                    onChange={(v) => {
                                        filterOutbox(v.value,startDate.value,endDate.value)
                                    }}
                                    className={styles.selectStyle}
                                />
                            </div>,
                            <RefreshBtn
                                key="r"
                                onClick={() => {
                                    getOutbox(true)
                                    onSubmit()
                                }}
                            />
                        ]
                    }
                    topPaginationElemR={this.archiveBtn(checkedItemCount, filteredEmails)}
                    middlePagination={true}
                    middlePaginationElem={[
                        <div className={styles.datePickerContainer} key={"pickerContainer"}>
                            <form onSubmit={onSubmit}>
                                <div className={`${styles.submitContainer}`}>
                                    <div className={`${styles.inputContainer}`}>
                                        <div className={`${styles.label}`}>
                                            <p>{_('fromDate')}</p>
                                        </div>
                                        <DatePicker className={styles.inputForm}
                                            {...startDate}
                                            startDate={startDate.value}
                                            endDate={endDate.value}
                                            maxDate={endDate.value}
                                        />
                                    </div>
                                    <div className={`${styles.inputContainer}`}>
                                        <div className={`${styles.label}`}>
                                            <p>{_('toDate')}</p>
                                        </div>
                                        <DatePicker
                                            className={styles.inputForm}
                                            {...endDate}
                                            startDate={startDate.value}
                                            endDate={endDate.value}
                                            minDate={startDate.value}
                                        />
                                    </div>
                                    <div className={`${styles.inputContainer}`}>
                                        <input className={`${styles.inputSubmit}`} type="button" onClick={onSubmit} value={_('filterDateBtn')}/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    ]}
                    filterable={[
                        "sentDate",
                        "recipient",
                        "toEmailAddress",
                        "subject",
                        "status",
                    ]}
                    ref={el => {this.table = el}}
                    id="table"
                    className="table"
                    sortable={[
                        {column: 'sentDate', sortFunction: 'Date'},
                        'recipient',
                        'toEmailAddress',
                        'subject',
                        'status',
                        {column: 'priority', sortFunction: 'Date'},
                    ]}
                    defaultSort={{
                        //column: 'sentDate',
                        column: 'priority',
                        direction: 'desc',
                    }}

                    itemsPerPage={50}
                    pageButtonLimit={5}
                >
                    <Thead>
                        <Th column="priority"
                            className={styles.hidden}
                        >
                            <strong>{_("priority")}</strong>
                        </Th>
                        <Th column="checkbox">
                            <input type="checkbox" checked={allSelected} onChange={this.handleCheckAll}/>
                        </Th>
                        <Th column="sentDate">
                            <strong>{_("sentDate")}</strong>
                        </Th>
                        <Th column="recipient">
                            <strong>{_("recipient")}</strong>
                        </Th>
                        <Th column="toEmailAddress">
                            <strong>{_("toEmailAddress")}</strong>
                        </Th>
                        <Th column="subject">
                            <strong>{_("subject")}</strong>
                        </Th>
                        <Th column="resend" label="">
                        </Th>
                        <Th column="status">
                            <strong>{_("status")}</strong>
                        </Th>
                    </Thead>

                    {filteredEmails.map((item, key) => {
                        const recipient = item.recipient || ''
                        const recipientTranslationKey = 'recipient'+recipient.charAt(0).toUpperCase() + recipient.slice(1)
                        const itemStatusTranslated = this.getStatusTextForList(item)
                        const trStyleArchived = item.archived ? `${styles.archived} clickable` : `clickable`
                        const trStyleFailedUnseen = (
                            (item.status == EMAIL_STATUS_FAILED ||
                             item.status == EMAIL_STATUS_BOUNCED)
                            && !item.seenInOutbox) ?
                            styles.failedUnSeen : ''
                        return (<Tr
                            className={cs(trStyleArchived,trStyleFailedUnseen,styles.trFirstColumnHidden)}
                            i={item.id}
                            key={key}
                            onClick={() => {zoomTo(item)}}
                        >
                            <Td
                                column="priority"
                                value={item.priority}
                            >
                                {item.priority}
                            </Td>
                            <Td column="checkbox" value={map(item.content, i => i).join(' ')}>
                                <div style={{width: 15}}>
                                    <input
                                        type="checkbox"
                                        onClick={ev => ev.stopPropagation()}
                                        onChange={ev => this.check(ev, item.id)}
                                        checked={item.checked}
                                    />
                                </div>
                            </Td>
                            <Td
                                column="sentDate"
                                value={// timestamp and id for correct sort
                                    (item.sentDate && moment(item.sentDate).format("X") || "") + item.id
                                }
                            >
                                {item.sentDate && moment(item.sentDate).format("DD/MM/YYYY HH:mm:ss") || ""}
                            </Td>
                            <Td column="recipient" value={item.recipient}>{_emailSenderTranslates(recipientTranslationKey)}</Td>
                            <Td column="toEmailAddress" value={item.toEmailAddress}>
                                <RenderEmails emails={item.toEmailAddress}/>
                            </Td>
                            <Td column="subject" value={item.subject}>{item.subject}</Td>
                            <Td column="resend">
                                {item && ((item.status == EMAIL_STATUS_FAILED || item.status == EMAIL_STATUS_BOUNCED) && (!item.wasResent)) ?
                                <button onClick={(ev)=>{
                                        ev.stopPropagation()
                                        this.onResendEmailClick(item)
                                    }}
                                    className={cs(`greyButton visible`, styles.resendButton)}>
                                    {_('resendEmail')}
                                </button>
                                : null}
                            </Td>
                            <Td column="status" value={item.status}>
                                {(item.status == EMAIL_STATUS_FAILED || item.status == EMAIL_STATUS_BOUNCED) ?
                                <a className={cs(styles.statusFailed, /* item.wasResent ? styles.statusResent : */ "")}
                                    onClick={(ev)=>{
                                        ev.stopPropagation()
                                        this.onItemStatusClick(item)
                                    }
                                }>
                                    {itemStatusTranslated}
                                </a> : itemStatusTranslated
                                }
                            </Td>
                        </Tr>)
                    }

                    )}
                </Table>
                <Modal
                    isOpen={archiveIsOpen}
                    style={customStyles}
                >
                    {this.archiveAllPopup()}
                </Modal>
                <Modal
                    isOpen={Boolean(statusExplainerIsOpen)}
                    style={customStyles}
                >
                    {this.statusExplainerPopup()}
                </Modal>
                <Modal
                    isOpen={Boolean(resendEmailPopupIsOpen)}
                    style={customModalStyles}
                >
                    {this.resendEmailPopup()}
                </Modal>
                <EmailServerConfigDialog
                    modalIsOpen={emailServerConfigModalIsOpen}
                    onCancel={()=>{
                        const {dispatch} = this.props
                        dispatch(hideEmailServerConfigModal(false))
                    }}
                    onConfirmation={(config)=>{
                        dispatch(saveEmailServer(config)).then(res => {
                        dispatch(hideEmailServerConfigModal(true))
                            if(res){
                                this.doOpenResendModal(selectedItem)
                                this.setState({selectedItem: null})
                            }
                        })
                    }}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/outbox/outboxEmailList.jsx